import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollWindowToTop } from '../utils/scrollNavigation';

/** ルート変更時に window を先頭へ */
const ScrollToTopOnNavigate = () => {
  const location = useLocation();

  useEffect(() => {
    scrollWindowToTop();
  }, [location.pathname, location.key]);

  return null;
};

export default ScrollToTopOnNavigate;
